module.exports = __webpack_public_path__ + "img/lidka1.0e8d8454.jpg";